import { LogSentryException } from "@shapr3d/frontend-lib";
import { useMutation } from "@tanstack/react-query";

import { hubspotDownloadLinkEmailTemplateId, hubspotProxyUrl } from "../config";
import useAccount from "./useAccount";

export const useHubspotSendDownloadLink = (sendId: string) => {
  const { data: accountData } = useAccount();
  return useMutation({
    mutationKey: [sendId, "send-download-link"],
    mutationFn: async () => {
      if (!accountData?.email) {
        throw new Error("No account email available");
      }
      const response = await fetch(`${hubspotProxyUrl}/send-download-link`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          emailId: hubspotDownloadLinkEmailTemplateId,
          message: {
            to: accountData?.email,
            sendId: sendId,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Send download link failed with status ${response.status}`);
      }

      return response;
    },
    onError: (error) => {
      LogSentryException({ messagePrefix: "Hubspot send download link failed", error });
    },
  });
};
